import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../CashBankAccountLedgerSlice";
import {
  fetchCashBankAccountLedger,
  fetchCashBankAccounts,
} from "../CashBankAccountLedgerThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { fetchCustomersBySearch } from "../../../../store/commonThunks/lookups";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const CashBankAccountLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, accounts } = useSelector(
    (state) => state.cashBankAccountLedger
  );

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    // initially fetch accounts
    // dispatch(fetchCustomersBySearch(""));
    dispatch(fetchCashBankAccounts());
  }, [dispatch]);
  const searchAccount = useCallback(
    (text) => dispatch(fetchCashBankAccounts(text)),
    [dispatch]
  );

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }

    dispatch(fetchCashBankAccountLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Search Account</label>
          {/* <SearchListAutoComplete
            optionsList={accounts.map((c) => ({
              sale_id: c.acc_id,
              display_text: c.acc_name,
            }))}
            onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
            placeholder="Account"
            showAddNew={false}
          /> */}
          <SearchListAutoComplete
            entityType="account"
            searchThunk={searchAccount}
            resultSelector={(state) => state.cashBankAccountLedger.accounts}
            onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
            placeholder="Account"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
        filters={filters}
        onChange={(fromDate, toDate) => {
        handleFilterChange("fromDate", fromDate);
        handleFilterChange("toDate", toDate);
        }}
      />

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default CashBankAccountLedgerFilters;
